module.exports = "/_next/static/media/8d623f21828e41657ec2de4144116d5f.svg";